export default [
  {
    login: "humaneguy",
    id: 39733548,
    node_id: "MDQ6VXNlcjM5NzMzNTQ4",
    avatar_url: "https://avatars.githubusercontent.com/u/39733548?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/humaneguy",
    html_url: "https://github.com/humaneguy",
    followers_url: "https://api.github.com/users/humaneguy/followers",
    following_url:
      "https://api.github.com/users/humaneguy/following{/other_user}",
    gists_url: "https://api.github.com/users/humaneguy/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/humaneguy/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/humaneguy/subscriptions",
    organizations_url: "https://api.github.com/users/humaneguy/orgs",
    repos_url: "https://api.github.com/users/humaneguy/repos",
    events_url: "https://api.github.com/users/humaneguy/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/humaneguy/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "carolinanonato",
    id: 44845754,
    node_id: "MDQ6VXNlcjQ0ODQ1NzU0",
    avatar_url: "https://avatars.githubusercontent.com/u/44845754?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/carolinanonato",
    html_url: "https://github.com/carolinanonato",
    followers_url: "https://api.github.com/users/carolinanonato/followers",
    following_url:
      "https://api.github.com/users/carolinanonato/following{/other_user}",
    gists_url: "https://api.github.com/users/carolinanonato/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/carolinanonato/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/carolinanonato/subscriptions",
    organizations_url: "https://api.github.com/users/carolinanonato/orgs",
    repos_url: "https://api.github.com/users/carolinanonato/repos",
    events_url: "https://api.github.com/users/carolinanonato/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/carolinanonato/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "michhub-dev",
    id: 57120467,
    node_id: "MDQ6VXNlcjU3MTIwNDY3",
    avatar_url: "https://avatars.githubusercontent.com/u/57120467?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/michhub-dev",
    html_url: "https://github.com/michhub-dev",
    followers_url: "https://api.github.com/users/michhub-dev/followers",
    following_url:
      "https://api.github.com/users/michhub-dev/following{/other_user}",
    gists_url: "https://api.github.com/users/michhub-dev/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/michhub-dev/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/michhub-dev/subscriptions",
    organizations_url: "https://api.github.com/users/michhub-dev/orgs",
    repos_url: "https://api.github.com/users/michhub-dev/repos",
    events_url: "https://api.github.com/users/michhub-dev/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/michhub-dev/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "Kengist",
    id: 61586873,
    node_id: "MDQ6VXNlcjYxNTg2ODcz",
    avatar_url: "https://avatars.githubusercontent.com/u/61586873?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Kengist",
    html_url: "https://github.com/Kengist",
    followers_url: "https://api.github.com/users/Kengist/followers",
    following_url:
      "https://api.github.com/users/Kengist/following{/other_user}",
    gists_url: "https://api.github.com/users/Kengist/gists{/gist_id}",
    starred_url: "https://api.github.com/users/Kengist/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/Kengist/subscriptions",
    organizations_url: "https://api.github.com/users/Kengist/orgs",
    repos_url: "https://api.github.com/users/Kengist/repos",
    events_url: "https://api.github.com/users/Kengist/events{/privacy}",
    received_events_url: "https://api.github.com/users/Kengist/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "FesoQue",
    id: 65207356,
    node_id: "MDQ6VXNlcjY1MjA3MzU2",
    avatar_url: "https://avatars.githubusercontent.com/u/65207356?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/FesoQue",
    html_url: "https://github.com/FesoQue",
    followers_url: "https://api.github.com/users/FesoQue/followers",
    following_url:
      "https://api.github.com/users/FesoQue/following{/other_user}",
    gists_url: "https://api.github.com/users/FesoQue/gists{/gist_id}",
    starred_url: "https://api.github.com/users/FesoQue/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/FesoQue/subscriptions",
    organizations_url: "https://api.github.com/users/FesoQue/orgs",
    repos_url: "https://api.github.com/users/FesoQue/repos",
    events_url: "https://api.github.com/users/FesoQue/events{/privacy}",
    received_events_url: "https://api.github.com/users/FesoQue/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "amirmohammad0000",
    id: 74311184,
    node_id: "MDQ6VXNlcjc0MzExMTg0",
    avatar_url: "https://avatars.githubusercontent.com/u/74311184?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/amirmohammad0000",
    html_url: "https://github.com/amirmohammad0000",
    followers_url: "https://api.github.com/users/amirmohammad0000/followers",
    following_url:
      "https://api.github.com/users/amirmohammad0000/following{/other_user}",
    gists_url: "https://api.github.com/users/amirmohammad0000/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/amirmohammad0000/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/amirmohammad0000/subscriptions",
    organizations_url: "https://api.github.com/users/amirmohammad0000/orgs",
    repos_url: "https://api.github.com/users/amirmohammad0000/repos",
    events_url:
      "https://api.github.com/users/amirmohammad0000/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/amirmohammad0000/received_events",
    type: "User",
    site_admin: false,
  },
];
